import React, { useEffect } from 'react';
import StatementOCRHeader from './StatementOCRHeader';
import { StatementOCRTabs } from './types';
import {
  StatementOCRLayout,
  StatementOCRMainSection,
  StatementOCRHeaderSection,
} from './StatementOCR.styles';
import StatementOCRUploadTab from './upload-tab/StatementOCRUploadTab';

interface StatementOCRProps {
  tab: StatementOCRTabs | undefined;
  updateQueryParams: (arg0: object) => void;
}

const StatementOCR = ({ tab, updateQueryParams }: StatementOCRProps) => {
  useEffect(() => {
    if (!tab) {
      updateQueryParams({ tab: StatementOCRTabs.UPLOAD });
    }
  }, [tab, updateQueryParams]);

  return (
    <StatementOCRLayout>
      <StatementOCRHeaderSection>
        <StatementOCRHeader tab={tab} updateQueryParams={updateQueryParams} />
      </StatementOCRHeaderSection>
      <StatementOCRMainSection>
        {tab === StatementOCRTabs.UPLOAD && <StatementOCRUploadTab />}
      </StatementOCRMainSection>
    </StatementOCRLayout>
  );
};

export default StatementOCR;
